import React from 'react';
import { Image, Form } from '@douyinfe/semi-ui';
import ImageSelector from '../../../ImageSelector';
import styles from './index.module.scss';

const AvatarSelector = ({ field, value, onChange, onSizeChange, onBorderRadiusChange, size, borderRadius }) => {
    return (
        <div className={styles.avatarSelector}>
            <ImageSelector
                value={value}
                onChange={onChange}
                previewSize={size}
                previewBorderRadius={borderRadius}
                renderPreview={({ imageUrl }) => (
                    imageUrl ? (
                        <Image
                            src={imageUrl}
                            width={size}
                            height={size}
                            alt="Avatar"
                            style={{
                                objectFit: 'cover',
                                borderRadius: borderRadius
                            }}
                            preview={false}
                        />
                    ) : (
                        <div
                            className={styles.emptyAvatar}
                            style={{
                                width: size,
                                height: size,
                                borderRadius: borderRadius
                            }}
                        />
                    )
                )}
            />
            <div style={{ marginTop: '12px' }}>
                <Form
                    layout="horizontal"
                    labelPosition="left"
                    initValues={{
                        avatarSize: size,
                        avatarBorderRadius: borderRadius
                    }}
                    onValueChange={(values, field) => {
                        if (field.avatarSize !== undefined) {
                            onSizeChange?.(values.avatarSize);
                        } else if (field.avatarBorderRadius !== undefined) {
                            onBorderRadiusChange?.(values.avatarBorderRadius);
                        }
                    }}
                >
                    <Form.InputNumber
                        field="avatarSize"
                        label="尺寸"
                        min={16}
                        max={120}
                        suffix="px"
                    />
                    <Form.InputNumber
                        field="avatarBorderRadius"
                        label="圆角"
                        min={0}
                        max={100}
                        suffix="px"
                    />
                </Form>
            </div>
        </div>
    );
};

export { AvatarSelector };
export default AvatarSelector;